import { render, staticRenderFns } from "./SkeletonLoading.vue?vue&type=template&id=c557b2be&scoped=true"
import script from "./SkeletonLoading.vue?vue&type=script&lang=js"
export * from "./SkeletonLoading.vue?vue&type=script&lang=js"
import style0 from "./SkeletonLoading.vue?vue&type=style&index=0&id=c557b2be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c557b2be",
  null
  
)

export default component.exports